import React, {Component} from "react";
import PropTypes from "prop-types";
import getHours from "date-fns/get_hours";
import differenceInMinutes from "date-fns/difference_in_minutes";
import getMinutes from "date-fns/get_minutes";
import WorkdayModel from "../models/workday";

export default class Timeline extends Component {
    renderItems = () => {
        let items = [];

        this.props.model.entries.forEach(entry => {
            let gridRow = Timeline.getGridRow(entry.begin);
            let gridRowSpan = Timeline.getGridRowSpan(entry.begin, entry.end);
            let className = entry.id === this.props.selectedEntry ? 'timeline-entry selected' : 'timeline-entry';

            items.push(
                <div
                    key={entry.id}
                    className={className}
                    style={{gridRow: gridRow + ' / span ' + gridRowSpan}}
                    onClick={() => this.props.onSelectedEntryChanged(entry.id)}
                />);
        });

        return items;
    };

    static getGridRow(begin) {
        let hours = getHours(begin);
        let minutes = getMinutes(begin);

        return hours * 4 + (minutes / 15);
    }

    static getGridRowSpan(begin, end) {
        let minutes = differenceInMinutes(end, begin);

        return minutes / 15;
    }

    render() {
        return (
            <div className="timeline">
                {this.renderItems()}
            </div>
        )
    }
}

Timeline.propTypes = {
    model: PropTypes.instanceOf(WorkdayModel).isRequired,
    selectedEntry: PropTypes.number,
    onSelectedEntryChanged: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Timeline.js